export const NAV = {
  dashboard: "nav-dashboard",
  employees: "nav-employees",
  vacation: "nav-vacation",
  appointments: "nav-appointments",
  documents: "nav-documents",
  todos: "nav-todos",
  time: "nav-time",
  feedback: "nav-feedback",
  profile: "nav-profile",
  notifications: "nav-notifications",
  audit: "nav-audit",
  logout: "btn-logout",
};

export const LOGIN = {
  email: "login-email-input",
  password: "login-password-input",
  submit: "login-submit-button",
  error: "login-error",
};

export const DASH = {
  kpiVacation: "kpi-vacation",
  kpiTodos: "kpi-todos",
  kpiTime: "kpi-time",
  kpiEmployees: "kpi-employees",
  clockIn: "btn-clock-in",
  clockOut: "btn-clock-out",
};
